export default __webpack_public_path__ + "static/media/22t.e7e0c9e7.jpg";